import React, { useState } from "react";
import "../educationWorkPrograms.css";
import { BOOK_SECTIONS } from "../../../utils/const";
import styles from "./EducationWorkProgramsBooksTable.module.css";
import BooksList from "./BooksList";

const EducationWorkProgramsBooksTable = ({
  data,
  onDelete,
  courseId,
  booksInfo,
}) => {
  const filterBooksBySection = (books) => {
    return BOOK_SECTIONS.map((item) => ({
      name: item.name,
      list: [...books].filter((book) => book.part === item.id),
    }));
  };

  const [isCompactView, setCompactView] = useState(false);

  const filteredBookList = filterBooksBySection(data);

  const onHandleDelete = (id) => {
    onDelete(id, courseId);
  };

  return (
    <div>
      <div className={styles.viewSwitch}>
        <div className={styles.viewSwitchTitle}>Отображение списка</div>
        <div>
          <button
            onClick={() => setCompactView(true)}
            className={isCompactView && styles.switchActive}
          >
            Компактно
          </button>
          <button
            onClick={() => setCompactView(false)}
            className={!isCompactView && styles.switchActive}
          >
            Развернуто
          </button>
        </div>
      </div>

      {filteredBookList.map((item, index) => (
        <React.Fragment key={`bookList${index}`}>
          {!!item.list.length && (
            <BooksList
              item={item}
              index={index}
              data={data}
              booksInfo={booksInfo}
              onHandleDelete={onHandleDelete}
              isCompactView={isCompactView}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default EducationWorkProgramsBooksTable;
